import { render, staticRenderFns } from "./LabelRequired.vue?vue&type=template&id=6e026fdd&"
import script from "./LabelRequired.vue?vue&type=script&lang=ts&"
export * from "./LabelRequired.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports